import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

@Injectable()
export class AuthProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }


  loginMultiplan(usuario, senha) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "operacao":"login",
        "usuario":usuario,
        "senha":senha
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'loginmultiplan';

      me.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }

  resetPasswordMultiplan({email}) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "operacao":"resetsenha",
        "email":email,
      };

      var requestData = JSON.stringify(data);
      let url = APIService.API_URL + 'loginmultiplan';

      me.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }

  updatePassowrdMultiplan(token, senha) {
    var me=this;
    this.header=APIService.getHeaderResetSenha(token);

    return new Promise((resolve, reject) => {
      var data = {
        "operacao":"updatepassword",
        "senha":senha
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'loginmultiplan';

      me.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }




/**
 * Login com CPF e senha
 * @param cpf Cpf do usuário
 * @param senha Senha
 */
  login(usuario, senha) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "operacao":"login",
        "usuario":usuario,
        "senha":senha,
        "grupo": APIService.GRUPO_VIDEOLIB
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'login';

      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na autenticação do serviço.'
              }
              me.itemret=errodatavazio;
            }

            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg="Acesso negado.";
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);

        });
    });
  }

  /**
   * Revalida o token
   * @param tokenJwt Token armazenado
   */
  refreshToken(tokenJwt): Promise<{Item: any, erro: string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "tokenJwt":tokenJwt
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'loginmultiplan?operacao=refresh&tokenJwt=' + tokenJwt;

      me.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }


  atualizaSenha(token, senha) {
    var me=this;
    this.header=APIService.getHeaderResetSenha(token);

    return new Promise((resolve, reject) => {
      var data = {
        "operacao":"updatepassword",
        "senha":senha
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'login';

      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na autenticação do serviço.'
              }
              me.itemret=errodatavazio;
            }

            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg="Acesso negado.";
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);

        });
    });
  }

  resetPassword(usuario) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "operacao":"resetsenha",
        "usuario":usuario
        };

      var requestData = JSON.stringify(data);
      let url = APIService.API_URL + 'login';

      me.http.post(url,requestData,{headers:me.header})
      .subscribe((result: any) => {
        ////console.log(result);
        //resolve(result.json());
        var jsonData = result;

        if (jsonData.length != 0) {
          if (jsonData.status_ret != "NOK") {
              var datasuccess = {
                'Item':jsonData,
                'erro':''
              }
              me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item':null,
              'erro':'Erro na autenticação do serviço.'
            }

            me.itemret = errodatavazio;
          }

          resolve(me.itemret);
        } else {
          var errodatavazio1 = {
            'Item':null,
            'erro':'Não há consultas.'
          }

          me.itemret = errodatavazio1;
        }
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else if(error.status == 400) {
          msg = error.error;
        } else {
          msg = error._body;
        }

        let errojson = msg;

        var errochamada = {
          'Item':null,
          'erro':errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }


  authAD(tokenAD) {
    ////console.log('tokenAd Microsoft:', tokenAD);

    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'loginmultiplan';
      var data = {
        "operacao":"loginad",
        "tokenad":tokenAD
      }
      var requestData=JSON.stringify(data);
      // //console.log(requestData);
      this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });

  }

}
